<template>
    <div class="modal fade" id="actionRemarksModal" tabindex="-1" role="dialog" aria-labelledby="actionRemarksTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="col-sm-4 text-left">
                        <h5 class="modal-title font-weight-bold" id="actionRemarksTitle">{{booked.crew}}</h5>
                    </div>

                    <div class="col-sm-4 text-left border-left">
                        <span class="font-weight-bold">Booked check-in :</span> {{booked.booked_check_in |  moment('D MMM YYYY')}}
                    </div>

                    <div class="col-sm-4 text-left border-left">
                        <span class="font-weight-bold">Booked check-out :</span> {{booked.booked_check_out |  moment('D MMM YYYY')}}
                    </div>

<!--                    <button type="button" class="close btn-sm" data-dismiss="modal" aria-label="Close" v-on:click="setThisNull">-->
<!--                        <span aria-hidden="true">&times;</span>-->
<!--                    </button>-->
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6 text-left">
                            <div class="form-group" v-if="actionType == 3">
                                <label for="extendDate" class="font-weight-bold">Extend Date:</label>
                                <input type="date" id="extendDate" class="form-control form-control-sm w-50" v-model="booked.booked_extend_date"/>
                            </div>

                            <div class="form-group">
                                <label for="extendRemarks" class="font-weight-bold">Remarks</label>
                                <input readonly type="text" id="countdown2" size="3" value="200" class="ml-3 text-muted border-0"><span class="text-muted">Characters Left</span>
                                <textarea class="form-control" id="extendRemarks" v-model="newRemarks.remarks" style="height: 200px; resize: none;" rows="3"  @keydown="limiteTextRemarks('extendRemarks','countdown2',200)"></textarea>
                            </div>
                        </div>

                        <div class="col-md-6 text-left">
                            <div class="form-group row ">
                                <label  class="font-weight-bold ml-3">Previous Remarks :</label>
                            </div>

                            <div class="form-group custom-scroll remarks-wrapper"  style="height:300px;">
                                <div class="mr-2">
                                    <div class="card mb-3" v-for="(remark,index) in remarks" :key="remark.id" :id="'cardRemarks'+index">
                                        <div class="card-body">
                                            <div class="card-title custom-label text-dark border-bottom">{{remark.subject ? remark.subject : '---'}}</div>
                                            <div class="card-text">
                                                <p>{{remark.remarks}}</p>
                                            </div>
                                        </div>

                                        <div class="card-footer">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="row" style="font-size: 12px;" >
                                                        <div class="col-sm-6">
                                                            <small class="text-muted">Created At : </small> <small class="font-weight-bold">{{remark.created_at | moment("DD MMM YYYY - HH:mm") }}</small>
                                                        </div>
                                                        <div class="col-sm-6 border-left border-dark">
                                                            <small class="text-muted">By : </small><small class="font-weight-bold">{{remark.remark_by}}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary" v-on:click="setActionSave">
                        Save changes
                    </button>
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" v-on:click="setThisNull">
                        <font-awesome-icon icon="times"/>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions,mapGetters} from 'vuex';
    import {appMixins} from '../../../mixins/app.mixins';

  export default {
    name: 'actionRemarks',
    mixins:[appMixins],
    props:{
      checkedIn : {type:Function},
      checkedOut : {type:Function},
      extend : {type:Function},
      checkConflict : {type:Function},
      actionType:Number,

    },
    data(){
      return{

      }
    },

    methods : {
      ...mapActions(['setNullNewRemark','setNullRemarks','setBookedNull']),

      setThisNull(){
        this.setNullNewRemark();
        this.setNullRemarks();
        this.setBookedNull();
      },

      setActionSave(){
        //1 check in , 2 check out, 3 extend
        switch (this.actionType) {
          case 1 :
            this.checkedIn();
            this.setNullNewRemark();
            break;

          case 2:
            this.checkedOut();
            this.setNullNewRemark();
            break;

          case 3:
            if(this.setExtend() != false){
              this.extend();
            }
            this.setNullNewRemark();
            break;
        }
      },

      setExtend(){
        return this.checkConflict();
      },
    },

    computed : {
      ...mapGetters(['newRemarks','remarks','booked']),
    },

    created() {

    },

    mounted() {
      //
    },

    destroyed() {
      //
    }
  };
</script>

<style scoped>
    .remarks-wrapper{
        overflow-y: scroll;
        overflow-x: hidden;
    }
</style>
